var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('rect',_vm._g({staticClass:"shadow-paint-rect",attrs:{"x":_vm.x,"y":_vm.y,"width":_vm.width,"height":_vm.height,"stroke":"none","fill":"transparent"}},_vm.listeners))}
var staticRenderFns = []

export { render, staticRenderFns }